import { render, staticRenderFns } from "./StoredValue.vue?vue&type=template&id=af141d52"
import script from "./StoredValue.vue?vue&type=script&lang=js"
export * from "./StoredValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports